import { Directive, EventEmitter, HostBinding, HostListener, Input, Output } from '@angular/core';


/**------------------------------------------------------
 * Table Sorting
 * -------------
 * Allows us to sort table columns based on the column values
 *
 * Theoretical Example:
 * The directive takes in the sortable column field and sets
 * the direction of the sorting when clicked on the th element
 *
 * Example:
 * --------
 * 	<th sortable="column_reference">...</th>
 */
@Directive({
    selector: 'th[ngSortableTableHeader]',
    standalone: false
})
export class NgSortableHeaderDirective {

	//** Configurations */
	readonly SORT_DIRECTION: Record<string, TypeNgSortDirection> = {
		asc		: 'desc',
		desc	: '',
		''		: 'asc'
	};

	@Input()  sortable 		: TypeNgSortColumn	  		 = '';
	@Input()  direction		: TypeNgSortDirection 		 = '';
	@Output() readonly sort : EventEmitter<INgSortEvent> = new EventEmitter<INgSortEvent>();


	static compare(
		v1: string | number | Date | boolean | string[],
		v2: string | number | Date | boolean | string[]
	): number {
		return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
	}

	rotate(): void {
		this.direction = this.SORT_DIRECTION[this.direction];
		this.sort.emit({ column: this.sortable, direction: this.direction });
	}


	/**------------------------------------------------------
	 * Host Bindings
	 */
	@HostBinding('class.asc')
	get isAscending(): boolean {
		return this.direction === 'asc';
	}

	@HostBinding('class.desc')
	get isDescending(): boolean {
		return this.direction === 'desc';
	}

	@HostListener('click')
	clicked(): void {
		this.rotate();
	}
}


//** Types -------------------------------------- */
export type TypeNgSortColumn	= string | string[];
export type TypeNgSortDirection = 'asc' | 'desc' | '';

//** Interfaces --------------------------------- */
export interface INgSortEvent {
	column		: TypeNgSortColumn;
	direction	: TypeNgSortDirection;
}
